import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getLoginUser, saveAccessLog } from './api/AuthApi';
import { setLogin } from './reducers/AuthSlice';

import { getProfile } from "./api/CommonApi";
import { setProfile } from './reducers/ProfileSlice';

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import MainPage from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import JoinPage from "./pages/JoinPage";
import RequestPage from "./pages/RequestPage";
import { PrivateRoute } from './router/PrivateRoute';

import 'devextreme/dist/css/dx.light.css';
import StaticPage from "./pages/StaticPage";
import BoardPage from "./pages/BoardPage";
import ShineFooter from "./components/ShineFooter";
import {useTypedSelector} from "./reducers";
import JoinNiceModuleSuccess from "./components/JoinNiceModuleSuccess";
import JoinNiceModuleFail from "./components/JoinNiceModuleFail";
import DataCatalogPage from "./pages/DataCatalogPage";
import RequestListPage from "./pages/RequestListPage";
import RequestDetail from "./pages/RequestDetail";
import FindIdPage from "./pages/FindIdPage";
import AdminLogPage from './pages/AdminLogPage';
import { handleError } from './error/ErrorHandler';
import MyPage from './pages/MyPage';
import Renewal from "./pages/Renewal";

const App = (): JSX.Element => {
    const { site, status } = useTypedSelector(state => state.profile);
    const dispatch = useDispatch();

    useEffect(() => {
        // 사이트 프로파일 가져오기
        getProfile()
            .then(res => {
                const profiles: string[] = res.data;
                let profile = profiles.filter(p => 'ncdc' === p || 'shine' === p)[0];
                dispatch(setProfile(profile));
                //일단 shine 만 access log
                const isSaveAccesslog = sessionStorage.getItem("isSaveAccessLog") === "Y";
                if(!isSaveAccesslog && profile === 'shine') {
                    saveAccessLog()
                        .then( res => {
                            if(res.status !== 200) return;
                            sessionStorage.setItem("isSaveAccessLog", "Y");
                        })
                        .catch( err => handleError(err));
                }
            })
            .catch( err => handleError(err));

        // 현재 로그인 되어 있는지 체크
        getLoginUser()
            .then( res => {
                const user = res.data;
                dispatch(setLogin(user))
            })
            .catch( err => handleError(err));
        
    }, [ dispatch ]);

    return (
        <React.Fragment>
            { status === 'done' && 
                <BrowserRouter>
                    <Header />
                    <Menu />
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        {/*<Route path="/renewal" element={<Renewal />} />*/}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/request" element={<PrivateRoute><RequestPage /></PrivateRoute>} />
                        <Route path="/request/list" element={<PrivateRoute><RequestListPage /></PrivateRoute>} />
                        <Route path="/request/list/:dataId" element={<PrivateRoute><RequestDetail /></PrivateRoute>} />
                        <Route path="/join" element={<JoinPage />} />
                        <Route path="/join/tel/certification/success" element={<JoinNiceModuleSuccess />} />
                        <Route path="/join/tel/certification/fail" element={<JoinNiceModuleFail />} />
                        <Route path="/static/:menuId" element={<StaticPage />} />
                        <Route path="/board/:menuId" element={<BoardPage type={'board'} />} />
                        <Route path="/board/:menuId/post/:brdId" element={<BoardPage type={'post'} />} />
                        <Route path="/board/:menuId/edit" element={<PrivateRoute><BoardPage type={'write'} /></PrivateRoute>} />
                        <Route path="/board/:menuId/edit/:brdId" element={<PrivateRoute><BoardPage type={'edit'} /></PrivateRoute>} />
                        <Route path="/catalog" element={<DataCatalogPage />} />
                        <Route path="/catalog/edit" element={<PrivateRoute auth={'A'}><DataCatalogPage type={'write'} /></PrivateRoute>} />
                        <Route path="/catalog/edit/:catalogId" element={<PrivateRoute auth={'A'}><DataCatalogPage type={'edit'} /></PrivateRoute>} />
                        <Route path="/find/id" element={<FindIdPage />} />
                        <Route path="/admin/log/:menuId" element={<PrivateRoute auth={'A'}><AdminLogPage /></PrivateRoute>} />
                        <Route path="/mypage/:menuId"element={<PrivateRoute><MyPage /></PrivateRoute>} />
                    </Routes>
                    { site === 'ncdc' ? <Footer /> : <ShineFooter /> }
                </BrowserRouter>
            }
        </React.Fragment>
    );
}

export default App;
